import { Container, Row, Col, Table } from 'react-bootstrap';
import React, { useState, useEffect } from 'react';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../firebase';
import Filter from './Filter';
import PaginationControl from '../calculations/PaginationControl';

const DbTable = () => {
  const [transactions, setTransactions] = useState([]);
  const [order, setOrder] = useState('desc');
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const itemsPerPage = 10;

  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        setLoading(true);
        const q = query(collection(db, 'transactions'), orderBy('createdAt', order));
        const querySnapshot = await getDocs(q);
        const data = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setTransactions(data);
      } catch (error) {
        console.error('Error fetching transactions:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchTransactions();
  }, [order]);

  const handleFilterChange = (e) => {
    setOrder(e.target.value);
    setCurrentPage(1);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = transactions.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(transactions.length / itemsPerPage);

  const formatDate = (timestamp) => {
    try {
      if (timestamp instanceof Date) {
        return timestamp.toLocaleString();
      } else if (timestamp && typeof timestamp.toDate === 'function') {
        return timestamp.toDate().toLocaleString();
      } else if (timestamp && timestamp.seconds) {
        return new Date(timestamp.seconds * 1000).toLocaleString();
      } else if (typeof timestamp === 'string') {
        return new Date(timestamp).toLocaleString();
      }
      return 'Invalid Date';
    } catch (error) {
      console.error('Error formatting date:', error);
      return 'Invalid Date';
    }
  };

  const getTransactionId = (item) => {
    return item.id || item.transactionId || 'N/A';
  };

  const getAmount = (item) => {
    const amount = item.amountSender || item.amount || 0;
    return typeof amount === 'number' ? amount.toFixed(2) : parseFloat(amount || 0).toFixed(2);
  };

  return (
    <section className="px-1 py-4 nav-body-bg btm-rad">
      <Container>
        <Row className="align-items-center justify-content-between flex-column flex-md-row text-center text-md-start">
          <Col xs="auto" className="mb-3 mb-md-0">
            <h3 className="text-h2">Recent Transactions</h3>
          </Col>
          <Col xs="auto">
            <Filter value={order} onChange={handleFilterChange} />
          </Col>
        </Row>

        <div className="table-responsive scrollable-table-y mt-4" style={{ minHeight: '100vh', overflowY: 'auto' }}>
          <style>
            {`
              @media (max-width: 768px) {
                .scrollable-table-y {
                  max-height: 300px;
                  overflow-y: auto;
                }
              }
            `}
          </style>
          <Table className="table-hover align-middle body-text-two mb-0 max-h-80vh">
            <thead className="sticky-top top-0" style={{ zIndex: 10, background: 'transparent !important' }}>
              <tr>
                <th className="transparent-header">Transaction ID</th>
                <th className="text-center transparent-header">Time & Date</th>
                <th className="text-center transparent-header">Recipient Phone</th>
                <th className="text-center transparent-header">Operator</th>
                <th className="text-center transparent-header">Amount</th>
                <th className="text-center transparent-header">Status</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="text-center py-4 transparent-header">
                    <div className="admin-loader"></div>
                  </td>
                </tr>
              ) : currentItems.length > 0 ? (
                currentItems.map((item, idx) => (
                  <tr key={item.id || idx} style={{ borderBottom: '1px solid var(--divider)' }}>
                    <td className="py-3 transparent-header">{getTransactionId(item)}</td>
                    <td className="py-3 transparent-header text-center">
                      {formatDate(item.createdAt || item.time)}
                    </td>
                    <td className="py-3 transparent-header text-center">{item.phone || 'N/A'}</td>
                    <td className="py-3 transparent-header text-center">
                      {item.operator?.name || item.operator || 'N/A'}
                    </td>
                    <td className="py-3 transparent-header text-center">
                     {getAmount(item)} {item.currencyCode || item.currency || 'USD'} 
                    </td>
                    <td
                      className={`py-3 transparent-header text-center ${item.status?.toLowerCase() === 'success' || item.status?.toLowerCase() === 'successful'
                        ? 'text-success'
                        : item.status?.toLowerCase() === 'failed' || item.status?.toLowerCase() === 'unsuccessful'
                          ? 'text-danger'
                          : 'text-warning'
                        }`}
                    >
                      {item.status || 'Pending'}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center transparent-header py-4">
                    No transactions found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>

        {totalPages > 1 && (
          <PaginationControl
            totalPages={totalPages}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        )}
      </Container>
    </section>
  );
};

export default DbTable;
